import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const getWeeklyDealSummaries = (orgId, dealId, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'GETTING_WEEKLY_DEAL_SUMMARIES' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/weekly-deal-summary`, {
            params: {
              'request-id': reqId,
              orgId: orgId,
              dealId: dealId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'GETTING_WEEKLY_DEAL_SUMMARIES_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'GETTING_WEEKLY_DEAL_SUMMARIES_FAILED',
              payload: `Failed to get weekly deal summaries`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'GETTING_WEEKLY_DEAL_SUMMARIES_FAILED',
            payload: `Failed to get weekly deal summaries`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'GETTING_WEEKLY_DEAL_SUMMARIES_FAILED',
        payload: `Failed to get weekly deal summaries`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default getWeeklyDealSummaries;
